<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 측정기간 -->
				<el-col :span="5">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001684') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 토크렌치번호 -->
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001695')"
						paramKey="mesEqipNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.mesEqipNo"
					>
					</search-input>
				</el-col>
				<!-- 토크렌치명 -->
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001696')"
						paramKey="mesEqipNm"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.mesEqipNm"
					>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/mmc/mmcm/TorqRgst/store/helpers';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {
			searchDate: '',
			searchDateRange: []
		};
	},
	components: { SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMmcAdmin) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getTorqRgstManagements_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	async created() {
		try {
			this.searchDateRange = [...this.getSearchDates_];
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'startDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const startDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'startDt', value: startDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	}
};
</script>

<style></style>
